import { render, staticRenderFns } from "./SDIStrategies.vue?vue&type=template&id=fc9596e0&scoped=true"
import script from "./SDIStrategies.vue?vue&type=script&lang=js"
export * from "./SDIStrategies.vue?vue&type=script&lang=js"
import style0 from "./SDIStrategies.vue?vue&type=style&index=0&id=fc9596e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9596e0",
  null
  
)

export default component.exports